/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MarketRouteRouteImport } from './routes/$market/route'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as MarketIndexRouteImport } from './routes/$market/index'
import { Route as MarketAssistantRouteImport } from './routes/$market/assistant'
import { Route as MarketChartLabRouteImport } from './routes/$market/chart-lab'
import { Route as MarketDashboardRouteImport } from './routes/$market/dashboard'
import { Route as MarketDigestRouteImport } from './routes/$market/digest'
import { Route as MarketPortfolioRouteImport } from './routes/$market/portfolio'
import { Route as MarketResearchRouteImport } from './routes/$market/research'
import { Route as MarketWatchlistRouteImport } from './routes/$market/watchlist'
import { Route as AiModelHealthRouteImport } from './routes/ai/model-health'
import { Route as MarketMarketMetricKeyRouteImport } from './routes/$market/market.$metricKey'
import { Route as MarketMarketActionRadarRouteImport } from './routes/$market/market.action-radar'
import { Route as MarketMarketSectorRotationRouteImport } from './routes/$market/market.sector-rotation'
import { Route as MarketSecuritiesSymbolBrokerBranchesRouteImport } from './routes/$market/securities.$symbol/broker-branches'
import { Route as MarketSecuritiesSymbolAiPredictionRouteImport } from './routes/$market/securities.$symbol/ai.prediction'
import { Route as MarketSecuritiesSymbolChipsMetricKeyRouteImport } from './routes/$market/securities.$symbol/chips.$metricKey'
import { Route as MarketSecuritiesSymbolFundamentalMetricKeyRouteImport } from './routes/$market/securities.$symbol/fundamental.$metricKey'
import { Route as MarketSecuritiesSymbolValuationMetricKeyRouteImport } from './routes/$market/securities.$symbol/valuation.$metricKey'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketRouteRoute = MarketRouteRouteImport.update({
  id: '/$market',
  path: '/$market',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketIndexRoute = MarketIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketAssistantRoute = MarketAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketChartLabRoute = MarketChartLabRouteImport.update({
  id: '/chart-lab',
  path: '/chart-lab',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketDashboardRoute = MarketDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketDigestRoute = MarketDigestRouteImport.update({
  id: '/digest',
  path: '/digest',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketPortfolioRoute = MarketPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketResearchRoute = MarketResearchRouteImport.update({
  id: '/research',
  path: '/research',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketWatchlistRoute = MarketWatchlistRouteImport.update({
  id: '/watchlist',
  path: '/watchlist',
  getParentRoute: () => MarketRouteRoute,
} as any)
const AiModelHealthRoute = AiModelHealthRouteImport.update({
  id: '/ai/model-health',
  path: '/ai/model-health',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketMarketMetricKeyRoute = MarketMarketMetricKeyRouteImport.update({
  id: '/market/$metricKey',
  path: '/market/$metricKey',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketMarketActionRadarRoute = MarketMarketActionRadarRouteImport.update({
  id: '/market/action-radar',
  path: '/market/action-radar',
  getParentRoute: () => MarketRouteRoute,
} as any)
const MarketMarketSectorRotationRoute =
  MarketMarketSectorRotationRouteImport.update({
    id: '/market/sector-rotation',
    path: '/market/sector-rotation',
    getParentRoute: () => MarketRouteRoute,
  } as any)
const MarketSecuritiesSymbolBrokerBranchesRoute =
  MarketSecuritiesSymbolBrokerBranchesRouteImport.update({
    id: '/securities/$symbol/broker-branches',
    path: '/securities/$symbol/broker-branches',
    getParentRoute: () => MarketRouteRoute,
  } as any)
const MarketSecuritiesSymbolAiPredictionRoute =
  MarketSecuritiesSymbolAiPredictionRouteImport.update({
    id: '/securities/$symbol/ai/prediction',
    path: '/securities/$symbol/ai/prediction',
    getParentRoute: () => MarketRouteRoute,
  } as any)
const MarketSecuritiesSymbolChipsMetricKeyRoute =
  MarketSecuritiesSymbolChipsMetricKeyRouteImport.update({
    id: '/securities/$symbol/chips/$metricKey',
    path: '/securities/$symbol/chips/$metricKey',
    getParentRoute: () => MarketRouteRoute,
  } as any)
const MarketSecuritiesSymbolFundamentalMetricKeyRoute =
  MarketSecuritiesSymbolFundamentalMetricKeyRouteImport.update({
    id: '/securities/$symbol/fundamental/$metricKey',
    path: '/securities/$symbol/fundamental/$metricKey',
    getParentRoute: () => MarketRouteRoute,
  } as any)
const MarketSecuritiesSymbolValuationMetricKeyRoute =
  MarketSecuritiesSymbolValuationMetricKeyRouteImport.update({
    id: '/securities/$symbol/valuation/$metricKey',
    path: '/securities/$symbol/valuation/$metricKey',
    getParentRoute: () => MarketRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$market': typeof MarketRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/admin': typeof AdminRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/$market/assistant': typeof MarketAssistantRoute
  '/$market/chart-lab': typeof MarketChartLabRoute
  '/$market/dashboard': typeof MarketDashboardRoute
  '/$market/digest': typeof MarketDigestRoute
  '/$market/portfolio': typeof MarketPortfolioRoute
  '/$market/research': typeof MarketResearchRoute
  '/$market/watchlist': typeof MarketWatchlistRoute
  '/ai/model-health': typeof AiModelHealthRoute
  '/$market/': typeof MarketIndexRoute
  '/$market/market/$metricKey': typeof MarketMarketMetricKeyRoute
  '/$market/market/action-radar': typeof MarketMarketActionRadarRoute
  '/$market/market/sector-rotation': typeof MarketMarketSectorRotationRoute
  '/$market/securities/$symbol/broker-branches': typeof MarketSecuritiesSymbolBrokerBranchesRoute
  '/$market/securities/$symbol/ai/prediction': typeof MarketSecuritiesSymbolAiPredictionRoute
  '/$market/securities/$symbol/chips/$metricKey': typeof MarketSecuritiesSymbolChipsMetricKeyRoute
  '/$market/securities/$symbol/fundamental/$metricKey': typeof MarketSecuritiesSymbolFundamentalMetricKeyRoute
  '/$market/securities/$symbol/valuation/$metricKey': typeof MarketSecuritiesSymbolValuationMetricKeyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/$market/assistant': typeof MarketAssistantRoute
  '/$market/chart-lab': typeof MarketChartLabRoute
  '/$market/dashboard': typeof MarketDashboardRoute
  '/$market/digest': typeof MarketDigestRoute
  '/$market/portfolio': typeof MarketPortfolioRoute
  '/$market/research': typeof MarketResearchRoute
  '/$market/watchlist': typeof MarketWatchlistRoute
  '/ai/model-health': typeof AiModelHealthRoute
  '/$market': typeof MarketIndexRoute
  '/$market/market/$metricKey': typeof MarketMarketMetricKeyRoute
  '/$market/market/action-radar': typeof MarketMarketActionRadarRoute
  '/$market/market/sector-rotation': typeof MarketMarketSectorRotationRoute
  '/$market/securities/$symbol/broker-branches': typeof MarketSecuritiesSymbolBrokerBranchesRoute
  '/$market/securities/$symbol/ai/prediction': typeof MarketSecuritiesSymbolAiPredictionRoute
  '/$market/securities/$symbol/chips/$metricKey': typeof MarketSecuritiesSymbolChipsMetricKeyRoute
  '/$market/securities/$symbol/fundamental/$metricKey': typeof MarketSecuritiesSymbolFundamentalMetricKeyRoute
  '/$market/securities/$symbol/valuation/$metricKey': typeof MarketSecuritiesSymbolValuationMetricKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$market': typeof MarketRouteRouteWithChildren
  '/account': typeof AccountRoute
  '/admin': typeof AdminRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/$market/assistant': typeof MarketAssistantRoute
  '/$market/chart-lab': typeof MarketChartLabRoute
  '/$market/dashboard': typeof MarketDashboardRoute
  '/$market/digest': typeof MarketDigestRoute
  '/$market/portfolio': typeof MarketPortfolioRoute
  '/$market/research': typeof MarketResearchRoute
  '/$market/watchlist': typeof MarketWatchlistRoute
  '/ai/model-health': typeof AiModelHealthRoute
  '/$market/': typeof MarketIndexRoute
  '/$market/market/$metricKey': typeof MarketMarketMetricKeyRoute
  '/$market/market/action-radar': typeof MarketMarketActionRadarRoute
  '/$market/market/sector-rotation': typeof MarketMarketSectorRotationRoute
  '/$market/securities/$symbol/broker-branches': typeof MarketSecuritiesSymbolBrokerBranchesRoute
  '/$market/securities/$symbol/ai/prediction': typeof MarketSecuritiesSymbolAiPredictionRoute
  '/$market/securities/$symbol/chips/$metricKey': typeof MarketSecuritiesSymbolChipsMetricKeyRoute
  '/$market/securities/$symbol/fundamental/$metricKey': typeof MarketSecuritiesSymbolFundamentalMetricKeyRoute
  '/$market/securities/$symbol/valuation/$metricKey': typeof MarketSecuritiesSymbolValuationMetricKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$market'
    | '/account'
    | '/admin'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/$market/assistant'
    | '/$market/chart-lab'
    | '/$market/dashboard'
    | '/$market/digest'
    | '/$market/portfolio'
    | '/$market/research'
    | '/$market/watchlist'
    | '/ai/model-health'
    | '/$market/'
    | '/$market/market/$metricKey'
    | '/$market/market/action-radar'
    | '/$market/market/sector-rotation'
    | '/$market/securities/$symbol/broker-branches'
    | '/$market/securities/$symbol/ai/prediction'
    | '/$market/securities/$symbol/chips/$metricKey'
    | '/$market/securities/$symbol/fundamental/$metricKey'
    | '/$market/securities/$symbol/valuation/$metricKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/admin'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/$market/assistant'
    | '/$market/chart-lab'
    | '/$market/dashboard'
    | '/$market/digest'
    | '/$market/portfolio'
    | '/$market/research'
    | '/$market/watchlist'
    | '/ai/model-health'
    | '/$market'
    | '/$market/market/$metricKey'
    | '/$market/market/action-radar'
    | '/$market/market/sector-rotation'
    | '/$market/securities/$symbol/broker-branches'
    | '/$market/securities/$symbol/ai/prediction'
    | '/$market/securities/$symbol/chips/$metricKey'
    | '/$market/securities/$symbol/fundamental/$metricKey'
    | '/$market/securities/$symbol/valuation/$metricKey'
  id:
    | '__root__'
    | '/'
    | '/$market'
    | '/account'
    | '/admin'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/$market/assistant'
    | '/$market/chart-lab'
    | '/$market/dashboard'
    | '/$market/digest'
    | '/$market/portfolio'
    | '/$market/research'
    | '/$market/watchlist'
    | '/ai/model-health'
    | '/$market/'
    | '/$market/market/$metricKey'
    | '/$market/market/action-radar'
    | '/$market/market/sector-rotation'
    | '/$market/securities/$symbol/broker-branches'
    | '/$market/securities/$symbol/ai/prediction'
    | '/$market/securities/$symbol/chips/$metricKey'
    | '/$market/securities/$symbol/fundamental/$metricKey'
    | '/$market/securities/$symbol/valuation/$metricKey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MarketRouteRoute: typeof MarketRouteRouteWithChildren
  AccountRoute: typeof AccountRoute
  AdminRoute: typeof AdminRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TermsRoute: typeof TermsRoute
  AiModelHealthRoute: typeof AiModelHealthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$market': {
      id: '/$market'
      path: '/$market'
      fullPath: '/$market'
      preLoaderRoute: typeof MarketRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$market/': {
      id: '/$market/'
      path: '/'
      fullPath: '/$market/'
      preLoaderRoute: typeof MarketIndexRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/assistant': {
      id: '/$market/assistant'
      path: '/assistant'
      fullPath: '/$market/assistant'
      preLoaderRoute: typeof MarketAssistantRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/chart-lab': {
      id: '/$market/chart-lab'
      path: '/chart-lab'
      fullPath: '/$market/chart-lab'
      preLoaderRoute: typeof MarketChartLabRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/dashboard': {
      id: '/$market/dashboard'
      path: '/dashboard'
      fullPath: '/$market/dashboard'
      preLoaderRoute: typeof MarketDashboardRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/digest': {
      id: '/$market/digest'
      path: '/digest'
      fullPath: '/$market/digest'
      preLoaderRoute: typeof MarketDigestRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/portfolio': {
      id: '/$market/portfolio'
      path: '/portfolio'
      fullPath: '/$market/portfolio'
      preLoaderRoute: typeof MarketPortfolioRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/research': {
      id: '/$market/research'
      path: '/research'
      fullPath: '/$market/research'
      preLoaderRoute: typeof MarketResearchRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/watchlist': {
      id: '/$market/watchlist'
      path: '/watchlist'
      fullPath: '/$market/watchlist'
      preLoaderRoute: typeof MarketWatchlistRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/ai/model-health': {
      id: '/ai/model-health'
      path: '/ai/model-health'
      fullPath: '/ai/model-health'
      preLoaderRoute: typeof AiModelHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$market/market/$metricKey': {
      id: '/$market/market/$metricKey'
      path: '/market/$metricKey'
      fullPath: '/$market/market/$metricKey'
      preLoaderRoute: typeof MarketMarketMetricKeyRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/market/action-radar': {
      id: '/$market/market/action-radar'
      path: '/market/action-radar'
      fullPath: '/$market/market/action-radar'
      preLoaderRoute: typeof MarketMarketActionRadarRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/market/sector-rotation': {
      id: '/$market/market/sector-rotation'
      path: '/market/sector-rotation'
      fullPath: '/$market/market/sector-rotation'
      preLoaderRoute: typeof MarketMarketSectorRotationRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/securities/$symbol/broker-branches': {
      id: '/$market/securities/$symbol/broker-branches'
      path: '/securities/$symbol/broker-branches'
      fullPath: '/$market/securities/$symbol/broker-branches'
      preLoaderRoute: typeof MarketSecuritiesSymbolBrokerBranchesRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/securities/$symbol/ai/prediction': {
      id: '/$market/securities/$symbol/ai/prediction'
      path: '/securities/$symbol/ai/prediction'
      fullPath: '/$market/securities/$symbol/ai/prediction'
      preLoaderRoute: typeof MarketSecuritiesSymbolAiPredictionRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/securities/$symbol/chips/$metricKey': {
      id: '/$market/securities/$symbol/chips/$metricKey'
      path: '/securities/$symbol/chips/$metricKey'
      fullPath: '/$market/securities/$symbol/chips/$metricKey'
      preLoaderRoute: typeof MarketSecuritiesSymbolChipsMetricKeyRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/securities/$symbol/fundamental/$metricKey': {
      id: '/$market/securities/$symbol/fundamental/$metricKey'
      path: '/securities/$symbol/fundamental/$metricKey'
      fullPath: '/$market/securities/$symbol/fundamental/$metricKey'
      preLoaderRoute: typeof MarketSecuritiesSymbolFundamentalMetricKeyRouteImport
      parentRoute: typeof MarketRouteRoute
    }
    '/$market/securities/$symbol/valuation/$metricKey': {
      id: '/$market/securities/$symbol/valuation/$metricKey'
      path: '/securities/$symbol/valuation/$metricKey'
      fullPath: '/$market/securities/$symbol/valuation/$metricKey'
      preLoaderRoute: typeof MarketSecuritiesSymbolValuationMetricKeyRouteImport
      parentRoute: typeof MarketRouteRoute
    }
  }
}

interface MarketRouteRouteChildren {
  MarketAssistantRoute: typeof MarketAssistantRoute
  MarketChartLabRoute: typeof MarketChartLabRoute
  MarketDashboardRoute: typeof MarketDashboardRoute
  MarketDigestRoute: typeof MarketDigestRoute
  MarketPortfolioRoute: typeof MarketPortfolioRoute
  MarketResearchRoute: typeof MarketResearchRoute
  MarketWatchlistRoute: typeof MarketWatchlistRoute
  MarketIndexRoute: typeof MarketIndexRoute
  MarketMarketMetricKeyRoute: typeof MarketMarketMetricKeyRoute
  MarketMarketActionRadarRoute: typeof MarketMarketActionRadarRoute
  MarketMarketSectorRotationRoute: typeof MarketMarketSectorRotationRoute
  MarketSecuritiesSymbolBrokerBranchesRoute: typeof MarketSecuritiesSymbolBrokerBranchesRoute
  MarketSecuritiesSymbolAiPredictionRoute: typeof MarketSecuritiesSymbolAiPredictionRoute
  MarketSecuritiesSymbolChipsMetricKeyRoute: typeof MarketSecuritiesSymbolChipsMetricKeyRoute
  MarketSecuritiesSymbolFundamentalMetricKeyRoute: typeof MarketSecuritiesSymbolFundamentalMetricKeyRoute
  MarketSecuritiesSymbolValuationMetricKeyRoute: typeof MarketSecuritiesSymbolValuationMetricKeyRoute
}

const MarketRouteRouteChildren: MarketRouteRouteChildren = {
  MarketAssistantRoute: MarketAssistantRoute,
  MarketChartLabRoute: MarketChartLabRoute,
  MarketDashboardRoute: MarketDashboardRoute,
  MarketDigestRoute: MarketDigestRoute,
  MarketPortfolioRoute: MarketPortfolioRoute,
  MarketResearchRoute: MarketResearchRoute,
  MarketWatchlistRoute: MarketWatchlistRoute,
  MarketIndexRoute: MarketIndexRoute,
  MarketMarketMetricKeyRoute: MarketMarketMetricKeyRoute,
  MarketMarketActionRadarRoute: MarketMarketActionRadarRoute,
  MarketMarketSectorRotationRoute: MarketMarketSectorRotationRoute,
  MarketSecuritiesSymbolBrokerBranchesRoute:
    MarketSecuritiesSymbolBrokerBranchesRoute,
  MarketSecuritiesSymbolAiPredictionRoute:
    MarketSecuritiesSymbolAiPredictionRoute,
  MarketSecuritiesSymbolChipsMetricKeyRoute:
    MarketSecuritiesSymbolChipsMetricKeyRoute,
  MarketSecuritiesSymbolFundamentalMetricKeyRoute:
    MarketSecuritiesSymbolFundamentalMetricKeyRoute,
  MarketSecuritiesSymbolValuationMetricKeyRoute:
    MarketSecuritiesSymbolValuationMetricKeyRoute,
}

const MarketRouteRouteWithChildren = MarketRouteRoute._addFileChildren(
  MarketRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MarketRouteRoute: MarketRouteRouteWithChildren,
  AccountRoute: AccountRoute,
  AdminRoute: AdminRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TermsRoute: TermsRoute,
  AiModelHealthRoute: AiModelHealthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
